// Libraries
var React = require('react');

// Styles
require('./OfficeLocation.scss');

class OfficeLocationModule extends React.Component {
	render() {
		return (		
			<div className={"office-location"}>
				<div className={"office-location__wrapper"}>
					<address className={"office-location__text"}>Lilywhite House, 782 High Road, London, N17 0BX</address>
				</div>
			</div>
		)
	}
}

module.exports = OfficeLocationModule;


// WEBPACK FOOTER //
// ./src/components/Footer/OfficeLocation/OfficeLocationModule.js